import RitualIcon from './RitualIcon';

export default RitualIcon;
export { RitualIcon };
